module.exports = __webpack_public_path__ + "img/0x1f7216fdb338247512ec99715587bb97bbf96eae.0fd4b838.png";